'use strict'

import React from 'react';

import Layout from './Layout.jsx';
import ProjectMenu from './components/ProjectMenu.jsx';
import Area from './components/Area2.jsx';
import Field from './components/Field3.jsx';
import currencies from '../app/utils/currencies.js';

import Translations from '../app/utils/translations.js';
let translations=new Translations([
    require('./add/labels/english.js'),
    require('./add/labels/norwegian.js')
]);

class ProjectProperties extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      programme:this.props.project!==undefined ? this.props.project.programme : undefined,
      portfolio:this.props.project!==undefined ? this.props.project.portfolio : undefined
    }
  }

  updatePortfolio(event) {
    this.setState({portfolio:event.target.value});
  }

  updateProgramme(event) {
    this.setState({programme:event.target.value!=="" ? event.target.value : undefined});
  }

  render() {
    let labels=translations.getTranslation(this.props);
    return (
      <div style={{marginTop:30}}>
        <Area title={labels.properties.title}>
          <Field
            title={labels.properties.fields.name.title}
            name="name"
            description={labels.properties.fields.name.description}
            value={this.props.project!==undefined ? this.props.project.name : undefined}
          />
          <Field
            title={labels.properties.fields.identifier.title}
            optional={true}
            name="identifier"
            description={labels.properties.fields.identifier.description}
            value={this.props.project!==undefined ? this.props.project.identifier : undefined}
          />
          {this.props.tenant!==undefined && this.props.tenant.portfolios!==undefined && this.props.tenant.portfolios.length>0 ? (
              <Field
                title={labels.properties.fields.portfolio.title}
                name="portfolio"
                help={labels.properties.fields.portfolio.help}
                value={this.state.portfolio}
                options={this.props.tenant.portfolios.map(portfolio=>({value:portfolio.id, text:portfolio.name}))}
                onChange={this.updatePortfolio.bind(this)}
                disabled={this.state.programme!==undefined}
              />
            ) : null}
            {this.props.tenant!==undefined && this.props.tenant.locations!==undefined && this.props.tenant.locations.length>0 ? (
              <Field
                title={labels.properties.fields.location.title}
                name="location"
                help={labels.properties.fields.location.help}
                value={this.props.project!==undefined ? this.props.project.location : undefined}
                options={this.props.tenant.locations.map(location=>({value:location.id, text:location.name}))}
              />
          ) : null}
          {this.props.tenant!==undefined && this.props.tenant.projectTypes!==undefined && this.props.tenant.projectTypes.length>0 ? (
            <Field
              title={labels.properties.fields.projectType.title}
              name="projectType"
              help={labels.properties.fields.projectType.help}
              value={this.props.project!==undefined ? this.props.project.projectType : undefined}
              options={this.props.tenant.projectTypes.map(item=>({value:item.id, text:item.name}))}
            />
          ) : null}
          {this.props.tenant!==undefined && this.props.tenant.departments!==undefined && this.props.tenant.departments.length>0 ? (
            <Field
              title={labels.properties.fields.department.title}
              name="department"
              help={labels.properties.fields.department.help}
              value={this.props.project!==undefined ? this.props.project.department : undefined}
              options={this.props.tenant.departments.map(item=>({value:item.id, text:item.name}))}
            />
          ) : null}
          {this.props.tenant!==undefined && this.props.tenant.categories!==undefined && this.props.tenant.categories.length>0 ? (
            <Field
              title={labels.properties.fields.category.title}
              name="category"
              help={labels.properties.fields.category.help}
              value={this.props.project!==undefined ? this.props.project.category : undefined}
              options={this.props.tenant.categories.map(item=>({value:item.id, text:item.name}))}
            />
          ) : null}
          {this.props.tenant!==undefined && this.props.tenant.currencies!==undefined && this.props.tenant.currencies.length>0 ? (
            <Field
              title={labels.properties.fields.currency.title}
              name="currency"
              help={labels.properties.fields.currency.help}
              value={this.props.project!==undefined ? this.props.project.currency : undefined}
              options={this.props.tenant.currencies.map(currency=>({value:currency, text:currency+" - "+currencies.find(item=>item.id===currency).title}))}
            />
          ) : null}
          {this.props.tenant!==undefined && this.props.tenant.programmes!==undefined && this.props.tenant.programmes.filter(programme=>programme.portfolio===this.state.portfolio).length>0 ? (
            <Field
              title={labels.properties.fields.programme.title}
              name="programme"
              help={labels.properties.fields.programme.help}
              value={this.state.programme}
              options={[{text:labels.programme.noProgramme,value:""}].concat(this.props.tenant.programmes.filter(programme=>programme.portfolio===this.state.portfolio).map(item=>({value:item.id, text:labels.programme.yesProgrammePrefix+item.name})))}
              optional={true}
              onChange={this.updateProgramme.bind(this)}
            />
          ) : null}
          {this.state.programme!==undefined ? (
            <input type="hidden" name="portfolio" value={this.state.portfolio}/>
          ) : null}
        </Area>
      </div>
    );
  }
}

class ProjectBackground extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props)[this.props.type!==undefined ? this.props.type : "background"];
    return (
      <Area title={labels.title}>
        {this.props.type==="product" ? (
          <Field title={labels.fields.description.title}
            optional={true}
            name="description"
            help={labels.fields.description.help}
            description={labels.fields.description.description}
            height="3"
            value={this.props.project!==undefined ? this.props.project.description : undefined}
          />
        ) : null }
        <Field title={labels.fields.background.title}
               optional={true}
               name="background"
               help={labels.fields.background.help}
               description={labels.fields.background.description}
               height="3"
          value={this.props.project!==undefined ? this.props.project.background : undefined}
        />
      {this.props.type!=="product" ? (
        <Field title={labels.fields.timing.title}
          optional={true}
          name="timing"
          help={labels.fields.timing.help}
          description={labels.fields.timing.description}
          height="3"
          value={this.props.project!==undefined ? this.props.project.timing : undefined}
        />
      ) : null }
      {this.props.type!=="programme" && this.props.type!=="product" ? (
        <Field
          title={labels.fields.bigPicture.title}
          optional={true}
          name="bigPicture"
          help={labels.fields.bigPicture.help}
          description={labels.fields.bigPicture.description}
          height="3"
          value={this.props.project!==undefined ? this.props.project.bigPicture : undefined}
        />
    ) : this.props.type==="product" ? (
      <Field
        title={labels.fields.vision.title}
        optional={true}
        name="vision"
        help={labels.fields.vision.help}
        description={labels.fields.vision.description}
        height="3"
        value={this.props.project!==undefined ? this.props.project.vision : undefined}
      />
    ) : (
        <Field
          title={labels.fields.successFactors.title}
          optional={true}
          name="successFactors"
          help={labels.fields.successFactors.help}
          description={labels.fields.successFactors.description}
          height="3"
          value={this.props.project!==undefined ? this.props.project.successFactors : undefined}
        />
      )}
      </Area>
    );
  }
}

export class RegisterProgramme extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).programme;
    return (
      <div style={{marginTop:30}}>
        <form action="/programmes" method="POST">
          {this.props.project!==undefined && this.props.project.id!==undefined ? (
            <input type="hidden" name="id" value={this.props.project.id}/>
          ) : null}
          {this.props.project!==undefined && this.props.backgroundEdit===true ? (
            <input type="hidden" name="edit" value="background"/>
          ) : null}
          <Area title={labels.properties.title}>
            <Field
              title={labels.fields.name.title}
              name="name"
              description={labels.fields.name.description}
              value={this.props.project.name}
            />
            <Field
              title={labels.fields.identifier.title}
              optional={true}
              name="identifier"
              description={labels.fields.identifier.description}
              value={this.props.project.identifier}
            />
            {this.props.tenant!==undefined && this.props.tenant.portfolios!==undefined && this.props.tenant.portfolios.length>0 ? (
                <Field
                  title={labels.fields.portfolio.title}
                  name="portfolio"
                  help={labels.fields.portfolio.help}
                  value={this.props.project.portfolio}
                  options={this.props.tenant.portfolios.map(portfolio=>({value:portfolio.id, text:portfolio.name}))}
                />
              ) : null}
            {this.props.tenant!==undefined && this.props.tenant.locations!==undefined && this.props.tenant.locations.length>0 ? (
              <Field
                title={labels.fields.location.title}
                name="location"
                help={labels.fields.location.help}
                value={this.props.project!==undefined ? this.props.project.location : undefined}
                options={this.props.tenant.locations.map(location=>({value:location.id, text:location.name}))}
              />
            ) : null}
            {this.props.tenant!==undefined && this.props.tenant.departments!==undefined && this.props.tenant.departments.length>0 ? (
              <Field
                title={labels.fields.department.title}
                name="department"
                help={labels.fields.department.help}
                value={this.props.project!==undefined ? this.props.project.department : undefined}
                options={this.props.tenant.departments.map(item=>({value:item.id, text:item.name}))}
              />
            ) : null}
          </Area>
          {this.props.backgroundEdit===undefined || this.props.backgroundEdit===true ? (
            <ProjectBackground {...this.props} type="programme"/>
          ) : null}
          <div style={{paddingTop: 30, paddingBottom:80, clear:"left", float:"none"}}>
            <input className="cancel" type="submit" name="cancel" value={labels.actions.cancel}/>
            {this.props.project!==undefined && this.props.project.id!==undefined ? (
              <input className="save" style={{marginLeft: 15}} type="submit" value={labels.actions.update+" "+(this.props.backgroundEdit===true ? labels.actions.background : labels.actions.project)}/>
            ) : (
              <input className="save" style={{marginLeft: 15}} type="submit" value={labels.actions.createProgramme}/>
            )}
          </div>
        </form>
      </div>
    );
  }
}

export class RegisterProduct extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props).product;
    return (
      <div style={{marginTop:30}}>
        <form action="/products" method="POST">
          {this.props.project!==undefined && this.props.project.id!==undefined ? (
            <input type="hidden" name="id" value={this.props.project.id}/>
          ) : null}
          {this.props.project!==undefined && this.props.backgroundEdit===true ? (
            <input type="hidden" name="edit" value="background"/>
          ) : null}
          <Area title={labels.properties.title}>
            <Field
              title={labels.fields.name.title}
              name="name"
              description={labels.fields.name.description}
              value={this.props.project.name}
            />
            <Field
              title={labels.fields.identifier.title}
              optional={true}
              name="identifier"
              description={labels.fields.identifier.description}
              value={this.props.project.identifier}
            />
            {this.props.tenant!==undefined && this.props.tenant.portfolios!==undefined && this.props.tenant.portfolios.length>0 ? (
                <Field
                  title={labels.fields.portfolio.title}
                  name="portfolio"
                  help={labels.fields.portfolio.help}
                  value={this.props.project.portfolio}
                  options={this.props.tenant.portfolios.map(portfolio=>({value:portfolio.id, text:portfolio.name}))}
                />
              ) : null}
            {this.props.tenant!==undefined && this.props.tenant.currencies!==undefined && this.props.tenant.currencies.length>0 ? (
              <Field
                title={labels.fields.currency.title}
                name="currency"
                help={labels.fields.currency.help}
                value={this.props.project!==undefined ? this.props.project.currency : undefined}
                options={this.props.tenant.currencies.map(currency=>({value:currency, text:currency+" - "+currencies.find(item=>item.id===currency).title}))}
              />
            ) : null}
            {this.props.tenant!==undefined && this.props.tenant.locations!==undefined && this.props.tenant.locations.length>0 ? (
              <Field
                title={labels.fields.location.title}
                name="location"
                help={labels.fields.location.help}
                value={this.props.project!==undefined ? this.props.project.location : undefined}
                options={this.props.tenant.locations.map(location=>({value:location.id, text:location.name}))}
              />
            ) : null}
            {this.props.tenant!==undefined && this.props.tenant.departments!==undefined && this.props.tenant.departments.length>0 ? (
              <Field
                title={labels.fields.department.title}
                name="department"
                help={labels.fields.department.help}
                value={this.props.project!==undefined ? this.props.project.department : undefined}
                options={this.props.tenant.departments.map(item=>({value:item.id, text:item.name}))}
              />
            ) : null}
          </Area>
          {this.props.backgroundEdit===undefined || this.props.backgroundEdit===true ? (
            <ProjectBackground {...this.props} type="product"/>
          ) : null}
          <div style={{paddingTop: 30, paddingBottom:80, clear:"left", float:"none"}}>
            <input className="cancel" type="submit" name="cancel" value={labels.actions.cancel}/>
            {this.props.project!==undefined && this.props.project.id!==undefined ? (
              <input className="save" style={{marginLeft: 15}} type="submit" value={labels.actions.update+" "+(this.props.backgroundEdit===true ? labels.actions.background : labels.actions.project)}/>
            ) : (
              <input className="save" style={{marginLeft: 15}} type="submit" value={labels.actions.createProgramme}/>
            )}
          </div>
        </form>
      </div>
    );
  }
}

export class RegisterRelease extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      programme:this.props.project!==undefined ? this.props.project.programme : undefined,
      portfolio:this.props.project!==undefined ? this.props.project.portfolio : undefined
    }
  }

  updatePortfolio(event) {
    this.setState({portfolio:event.target.value});
  }

  updateProgramme(event) {
    this.setState({programme:event.target.value!=="" ? event.target.value : undefined});
  }

  render() {
    let labels=translations.getTranslation(this.props).release;
    return (
      <div style={{marginTop:30}}>
        <form action="/releases" method="POST">
          {this.props.project!==undefined && this.props.project.id!==undefined ? (
            <input type="hidden" name="id" value={this.props.project.id}/>
          ) : null}
          <Area title={labels.properties.title}>
            <Field
              title={labels.fields.name.title}
              name="name"
              description={labels.fields.name.description}
              help={labels.fields.name.help}
              value={this.props.project.name}
              readonly={true}
            />
            <Field
              title={labels.fields.identifier.title}
              optional={true}
              name="identifier"
              description={labels.fields.identifier.description}
              value={this.props.project.identifier}
            />
            {this.props.tenant!==undefined && this.props.tenant.portfolios!==undefined && this.props.tenant.portfolios.length>0 ? (
                <Field
                  title={labels.fields.portfolio.title}
                  name="portfolio"
                  help={labels.fields.portfolio.help}
                  value={this.props.project.portfolio}
                  options={this.props.tenant.portfolios.map(portfolio=>({value:portfolio.id, text:portfolio.name}))}
                  disabled={this.state.programme!==undefined}
                />
              ) : null}
            {this.props.tenant!==undefined && this.props.tenant.programmes!==undefined && this.props.tenant.programmes.filter(programme=>programme.portfolio===this.state.portfolio).length>0 ? (
              <Field
                title={labels.fields.programme.title}
                name="programme"
                help={labels.fields.programme.help}
                value={this.state.programme}
                options={[{text:labels.noProgramme,value:""}].concat(this.props.tenant.programmes.filter(programme=>programme.portfolio===this.state.portfolio).map(item=>({value:item.id, text:labels.yesProgrammePrefix+item.name})))}
                optional={true}
                onChange={this.updateProgramme.bind(this)}
              />
            ) : null}
            {this.state.programme!==undefined ? (
              <input type="hidden" name="portfolio" value={this.state.portfolio}/>
            ) : null}
          </Area>
          <div style={{paddingTop: 30, paddingBottom:80, clear:"left", float:"none"}}>
            <input className="cancel" type="submit" name="cancel" value={labels.actions.cancel}/>
            {this.props.project!==undefined && this.props.project.id!==undefined ? (
              <input className="save" style={{marginLeft: 15}} type="submit" value={labels.actions.update+" "+(this.props.backgroundEdit===true ? labels.actions.background : labels.actions.project)}/>
            ) : (
              <input className="save" style={{marginLeft: 15}} type="submit" value={labels.actions.createProgramme}/>
            )}
          </div>
        </form>
      </div>
    );
  }
}

class SelectProgramOrProject extends React.Component {
  constructor(props) {
    super(props);
    this.state={name:"",identifier:""};
  }

  updateField(event) {
    event.preventDefault();
    this.setState({[event.target.name]: event.target.value});
  }

  selectProject(event) {
    event.preventDefault();
    this.setState({type:"project"});
  }

  selectProgramme(event) {
    event.preventDefault();
    this.setState({type:"programme"});
  }

  selectProduct(event) {
    event.preventDefault();
    this.setState({type:"product"});
  }

  render() {
    let labels=translations.getTranslation(this.props).initiative;
    return this.state.type==="project" ? (
      <RegisterProject
        {...this.props}
        project={Object.assign({},this.props.project, {
          name: this.state.name,
          identifier: this.state.identifier,
          portfolio: this.state.portfolio
        })}
      />
    ) : this.state.type==="programme" ? (
      <RegisterProgramme
        {...this.props}
        project={Object.assign({},this.props.project, {
          name: this.state.name,
          identifier: this.state.identifier,
          portfolio: this.state.portfolio
        })}
      />
  ) : this.state.type==="product" ? (
    <RegisterProduct
      {...this.props}
      project={Object.assign({},this.props.project, {
        name: this.state.name,
        identifier: this.state.identifier,
        portfolio: this.state.portfolio
      })}
    />

  ) : (
      <div style={{marginTop:30}}>
        <Area title={labels.title}>
          <Field
            title={labels.fields.name.title}
            name="name"
            description={labels.fields.name.description}
            value={this.state.name}
            onChange={this.updateField.bind(this)}
          />
          <Field
            title={labels.fields.identifier.title}
            optional={true}
            name="identifier"
            description={labels.fields.identifier.description}
            value={this.state.identifier}
            onChange={this.updateField.bind(this)}
          />
          {this.props.tenant!==undefined && this.props.tenant.portfolios!==undefined && this.props.tenant.portfolios.length>0 ? (
              <Field
                title={labels.fields.portfolio.title}
                name="portfolio"
                help={labels.fields.portfolio.help}
                value={this.state.portfolio}
                options={this.props.tenant.portfolios.map(portfolio=>({value:portfolio.id, text:portfolio.name}))}
                onChange={this.updateField.bind(this)}
              />
            ) : null}
        </Area>
        <div style={{display: "grid", gridGap:"10px", gridAutoColumns: "1fr", gridAutoRows:"1fr", width:"100%", flexWrap:"wrap", justifyContent: "space-between", fontFamily:"Arial, Verdana, Geneva, sans-serif"}}>
          <div style={{flexBasis:"49%", cursor: "pointer", borderRadius: 2, margin: 2, border:"solid 1px #8faadc", backgroundColor:"#b4c7e7", color: "#203864"}} onClick={this.selectProject.bind(this)}>
            <h3>{labels.fields.asProject}</h3>
            <ul style={{textAlign:"left"}}>
              {labels.fields.projectCharacteristics.map((item,index)=><li key={index}>{item}</li>)}
            </ul>

          </div>
          <div style={{gridColumn:"2/2", cursor: "pointer", borderRadius: 2, margin: 2, border:"solid 1px #8faadc", backgroundColor:"#b4c7e7", color: "#203864"}} onClick={this.selectProgramme.bind(this)}>
            <h3>{labels.fields.asProgramme}</h3>
            <ul style={{textAlign:"left"}}>
              {labels.fields.programmeCharacteristics.map((item,index)=><li key={index}>{item}</li>)}
            </ul>
          </div>
          <div style={{gridColumn:"1/2",gridRow:"2/2", cursor: "pointer", borderRadius: 2, margin: 2, border:"solid 1px #8faadc", backgroundColor:"#b4c7e7", color: "#203864"}} onClick={this.selectProduct.bind(this)}>
            <h3>{labels.fields.asProduct}</h3>
            <ul style={{textAlign:"left"}}>
              {labels.fields.productCharacteristics.map((item,index)=><li key={index}>{item}</li>)}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export class NewProject extends React.Component {
  render() {
    return this.props.version===2 ? (
      <div style={{textAlign: "center", display:"flex", justifyContent:"center"}}>
        <div style={{width:1016}}>
          <SelectProgramOrProject {...this.props}/>
        </div>
      </div>
    ) : (
      <RegisterProject {...this.props}/>
    );
  }
}

class RegisterProject extends React.Component {
  render() {
    let labels=translations.getTranslation(this.props);
    let type=this.props.project!==undefined
      ? this.props.project.isProgramme===true
        ? "programme"
        : this.props.project.isProduct===true
          ? "product"
          : undefined
      : undefined;
    return (
      <div style={{textAlign: "center", display:"flex", justifyContent:"center"}}>
        <div style={{width:1016}}>
          <form action={this.props.project!==undefined && this.props.project.isProgramme===true ? "/programmes/" : this.props.project!==undefined && this.props.project.isProduct!==undefined ? "/products/" : "/projects/"} method="POST">
            {this.props.project!==undefined && this.props.project.id!==undefined ? (
              <input type="hidden" name="id" value={this.props.project.id}/>
            ) : null}
            {this.props.project!==undefined && this.props.backgroundEdit!==true ? (
              <input type="hidden" name="edit" value="properties"/>
            ) : (
              <input type="hidden" name="edit" value="background"/>
            )}
            {this.props.backgroundEdit!==true ? (
              <ProjectProperties {...this.props}/>
            ) : null}
            {this.props.project===undefined || this.props.project.id===undefined || this.props.backgroundEdit===true? (
              <div>
                <ProjectBackground
                  {...this.props}
                  type={type}/>
              </div>
            ) : null}
            <div style={{paddingTop: 30, paddingBottom:80, clear:"left", float:"none"}}>
              <input className="cancel" type="submit" name="cancel" value={labels.actions.cancel}/>
              {this.props.project!==undefined && this.props.project.id!==undefined ? (
                <input className="save" style={{marginLeft: 15}} type="submit" value={labels.actions.update+" "+(this.props.backgroundEdit===true ? type!==undefined && labels[type].actions.background !==undefined ? labels[type].actions.background : labels.actions.background : labels.actions.project)}/>
              ) : (
                <input className="save" style={{marginLeft: 15}} type="submit" value={labels.actions.createProject}/>
              )}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default class NewProjectPage extends React.Component {
  render() {
    var menu=(this.props.showMenu===true) ? <ProjectMenu {...this.props}/> : undefined;
    return (
      <Layout {...this.props} projectMenu={menu}>
        <NewProject {...this.props}/>
      </Layout>
    );
  }
}



// WEBPACK FOOTER //
// ./views/NewProject.jsx